import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { CATEGORIES } from './journal-main.mock';
import { ActivatedRoute, Router } from '@angular/router';
import { JournalMainService, NB_ARTICLES_PER_PAGE, DEFAULT_CATEGORY } from './journal-main.service';
import { IjournalCategory } from './journal-main.interface';
import { journalMainPageMetas } from '@app/shared/static/metas';
import { Subject } from 'rxjs';
import { PageService } from '@app/core/content/services';
import { LocaleService } from '@app/core/i18n';
import { IJournalPages } from './interfaces/journal-main.interface';
import { Breadcrumb } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-journal-main',
  templateUrl: './journal-main.component.html',
  styleUrls: ['./journal-main.component.scss']
})
export class JournalMainComponent implements OnInit, OnDestroy {
  public defaultCategory = DEFAULT_CATEGORY;
  public currentCategory: IjournalCategory = this.defaultCategory;
  public categoryList: IjournalCategory[] = CATEGORIES;
  public postList = [];
  public currentPage = 1;
  public nbTotalArticles: number;
  public nbArticlesTODisplay = NB_ARTICLES_PER_PAGE;
  public pending = false;
  public showIntro = false;
  public nbOfPages: number;
  public pageBreadcrumb: Array<Breadcrumb> = [];
  public articlesPagination: IJournalPages;
  next: string;
  private ngUnsubscribe = new Subject<void>();

  @ViewChild('showMore', { read: ElementRef }) showMore;

  constructor(
    private journalMainService: JournalMainService,
    private ref: ChangeDetectorRef,
    private pageService: PageService,
    private localeService: LocaleService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    this.journalMainService.getCategories().subscribe(
      data => {
        if (data) {
          this.categoryList = data;
        }
      },
      error => {
        console.error(error);
      }
    );
  }

  ngOnInit() {
    this.route.data.subscribe(
      data => {
        if (data?.pageData[0]?.list) {
          const [categories, editos] = data.pageData;
          this.categoryList = categories.list;
          this.currentCategory = categories.current || this.defaultCategory;
          this.postList = editos ? editos.editoList : [];
          this.nbTotalArticles = editos ? editos.count : 0;
          this.nbOfPages = Math.ceil(this.nbTotalArticles / this.nbArticlesTODisplay);
          this.currentPage = editos ? editos.pageNb : 1;
          let currentPath = editos ? editos.path : '';
          if (currentPath && currentPath.includes('p-')) {
            currentPath = currentPath.slice(0, currentPath.indexOf('p-'));
          }

          this.articlesPagination = {
            current: this.currentPage,
            total: this.nbOfPages,
            path: currentPath,
            category: this.currentCategory.id
          };
        } else {
          this.pending = false;
          this.ref.detectChanges();
        }
        this._updatePageData();
      },
      error => {
        console.error(error);
      }
    );
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  updateCurrentCategory(event, category: IjournalCategory) {
    this.currentCategory = category;
    this.ref.detectChanges();
    event.stopPropagation();
  }

  setCategoryClasses(catId: string): string {
    const active = catId && this.currentCategory.id === catId ? ' active' : '';
    return `vc-btn vc-btn--medium vc-btn--chip${active}`;
  }

  private _updatePageData(): void {
    if (!journalMainPageMetas) {
      return;
    }
    const lang = this.localeService.getLanguage();
    const path = this.router.url.toLowerCase();
    let title = String(journalMainPageMetas[lang].title);
    let description = String(journalMainPageMetas[lang].description);
    if (this.currentCategory.id !== '' && this.currentPage > 1) {
      title += ` - p${this.currentPage}`;
      description += ` - p${this.currentPage}`;
    }
    this.pageService.setTitle(title);
    this.pageService.setDescription(description);
    this.pageService.setCanonicalVersion(path);
    this.pageService.initAlternateLinks(path);
    this.pageService.setRobots({ index: true, follow: true });
    this.pageService.removeKeywords();
  }
}
